module.exports = __webpack_public_path__ + "assets/media/4.aefa9437.wav";